export class NodePolyfillUtils {
  static init() {
    // @ts-expect-error: mapped from ts-ignore
    window.process = {
      nextTick: (callback: Function) => setTimeout(callback, 0), // eslint-disable-line @typescript-eslint/no-unsafe-function-type
    };
  }
}
